import * as React from "react";

import Slider from "react-slick";
import classes from './Banner.module.scss';
import LeftArrow from '../../assets/icons/ChevronLeft.svg';
import RightArrow from '../../assets/icons/ChevronRight.svg';
import { useNavigate } from "react-router-dom";
import { LAUNCH_MODE } from "../../siteConfig";

export const Banner = ({ bannerData, onSlideClick }) => {
    const navigate = useNavigate();

    // In launch mode `/products` does not exist, so the caller supplies its own
    // handler (scroll to the newsletter form) instead of navigating.
    const handleSlideClick = () => {
        if (onSlideClick) return onSlideClick();
        if (LAUNCH_MODE) return;
        navigate('/products');
    };
    const SlickArrowLeft = ({ currentSlide, slideCount, ...props }) => (
        <img src={LeftArrow} alt="prevArrow" {...props} className={classes.ArrowLeft} />
      );
    
      const SlickArrowRight = ({ currentSlide, slideCount, ...props }) => (
        <img src={RightArrow} alt="nextArrow" {...props} className={classes.ArrowRight}/>
      );

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: <SlickArrowLeft />,
        nextArrow: <SlickArrowRight />,
    };
    return (
        <div className={classes.CarouselContainer}>
            <Slider {...settings} className={classes.Carousel}>
                {bannerData.map((data) => {
                    return (
                        <div className={classes.box}>
                            <img className={classes.boxImage} onClick={handleSlideClick} alt="carousel" src={data.productImage} />
                            {/* <div className={classes.boxText}>
                                <div className={classes.boxTextTitle}>
                                    {data.text}
                                </div>
                                <div onClick={() => console.log(data.productId)} className={classes.buyProduct}>
                                    Shop Now
                                </div>
                            </div> */}
                        </div>

                    );
                })}

            </Slider>
        </div>
    );

}